import type { IData } from './BlockchainUseCases.types';

export const data: IData = {
  devaWallet: {
    headline: {
      title: 'We design and develop our own Web3 products - check them out!',
    },
    infoSections: [
      {
        title:
          'Deva Wallet - mobile web3 wallet with the simplest onboarding flow',
        description:
          'With the introduction of EIP-4337, known broadly as Account Abstraction, we’ve entered a new era of Web3 accessibility and adoption. At Rumble Fish, we understand the market tendencies and current and future customer needs. That is one of the reasons for developing our own Account Abstraction wallet - the Deva Wallet.',
      },
      {
        description:
          'Deva Wallet is an EIP-4337 mobile wallet redefining the way users interact with Web3 and smart contracts. It has the simplest onboarding flow - no more complicated transactions, just a simple QR code to enter the world of Web3.',
      },
      {
        title: 'Deva Wallet - let web2 users into your web3 app!',
      },
    ],
  },
  evmDebugger: {
    headline: {
      title: 'EVM Debugger - analyze the EVM transaction in one simple step',
    },
    infoSections: [
      {
        description: `We’re a team of <strong>blockchain developers on a mission to make Web3 solutions more accessible</strong> to everyday users. We have years of experience in commercial projects like crypto exchanges, lending protocols, NFT marketplaces, and more, and we also like to contribute to the broader developer community by building free tools.`,
      },
      {
        description: `Our own free tool for EVM developers - <u>EVM Debugger</u> - is a unique solution for blockchain developers that enables easy and user-friendly analysis of EVM smart contracts.`,
      },
    ],
  },
};
